import React from "react";
import {
  EditPageContainer,
  Page,
  withServerErrors,
} from "components/common";
import GetBack from "components/refactoring/BackButton";
import { compose } from "recompose";

import { useTranslation } from "react-i18next";
import { EditForm } from "../EditForm";

export const ModuleEdit = ({
  mode,
  item,
  match,
}) => {

  const {t} = useTranslation()

  const codeOptions = [
    {value: "payroll", label: "Payroll"},
    {value: "accounting", label: "Accounting"},
    {value: "wpconnect", label: "E-Invoicing"},
    {value: "custom_invoice", label: "Custom Invoice"},
    // {value: "halfpart", label: t("HalfPart")},
  ]

  const categoryOptions = [
    { value: 'Sales', label: 'Sales' },
    { value: 'Services', label: 'Services' },
    { value: 'Accounting', label: 'Accounting' },
    { value: 'Inventory', label: 'Inventory' },
    { value: 'Manufacturing', label: 'Manufacturing' },
    { value: 'Marketing', label: 'Marketing' },
    { value: 'Human Resources', label: 'Human Resources' },
    { value: 'Productivity', label: 'Productivity' },
    { value: 'Other', label: 'Other' },
  ];

  return (
    <Page title={t(`${mode} Module`)}>
      <GetBack styleClass="my-2"/>
      <EditForm 
        type="Module"
        options={codeOptions}
        category={categoryOptions}
        item={item} 
        mode={mode} 
        match={match} 
        t={t} 
        pushURL="/core/modules" 
      />
    </Page>
  );
};

const enhance = compose(
  withServerErrors(),
  EditPageContainer({
    url: "core/hesaab_module",
  }),
);

export default enhance(ModuleEdit);
